module.exports = __webpack_public_path__ + "img/earrings.14701194.svg";